import { __rest } from "tslib";
import React from "react";
import { StyledLink } from "./styles";
var Hyperlink = function (_a) {
    var children = _a.children, icon = _a.icon, onClick = _a.onClick, href = _a.href, target = _a.target, rest = __rest(_a, ["children", "icon", "onClick", "href", "target"]);
    return (React.createElement(StyledLink, { href: href, target: target, onClick: function (e) {
            if (onClick) {
                onClick(e);
            }
        }, style: rest },
        icon,
        children));
};
Hyperlink.defaultProps = {
    href: undefined,
    onClick: function () { },
    color: "#58ceb1",
    target: "_blank"
};
export default Hyperlink;
//# sourceMappingURL=index.js.map